import { Component } from 'react'
import { Container, Row, Col } from 'reactstrap'
import withApolloClient from '../withApolloClient'
import SubrogationClaimListHeader from './SubrogationClaimListHeader'
import SubrogationClaimList from './SubrogationClaimList'
import SubrogationClaimActions from './SubrogationClaimActions'
import './Incidents.css'

const tableHeaders = [
    { id: "date_added", name: "Date Added", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "claim_number", name: "Claim #", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "assignedTo", name: "Assigned To", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "payment_id", name: "Payment ID", sortable: false, preferenceSettings: { isVisible: false, canToggleVisibility: true, canReorder: true } },
    { id: "requested_amount", name: "Requested Amount", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "gross_collected", name: "Gross Collected", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "net_collected", name: "Net Collected", sortable: false, preferenceSettings: { isVisible: false, canToggleVisibility: true, canReorder: true } },
    { id: "tpa_expenses", name: "TPA Expenses", sortable: false, preferenceSettings: { isVisible: false, canToggleVisibility: true, canReorder: true } },
    { id: "incident_name", name: "Incident Name", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "incident_date", name: "Incident Date", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "party", name: "Party", sortable: false, preferenceSettings: { isVisible: false, canToggleVisibility: true, canReorder: true } },
    { id: "tpa", name: "TPA", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "status", name: "Status", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "filed_date", name: "Filed Date", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "acknowledgment_date", name: "Acknowledgment Date", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "incident_branch", name: "Incident Branch", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "adjuster", name: "Adjuster", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "in_litigation", name: "In Litigation", sortable: false, preferenceSettings: { isVisible: false, canToggleVisibility: true, canReorder: true } },
]
const getDefaultColumnConfig = () => tableHeaders.map((column, index) => ({ ...column, order: index }))

class SubrogationClaimListContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            orderBy: ["-date_added"],
            filterValues: { isArchived: false },
            columnConfig: getDefaultColumnConfig(),
        }
    }
    setColumnConfig = (columnConfig) => this.setState({ columnConfig })

    updateOrder = (string) => {
        let order = this.state.orderBy ? [...this.state.orderBy] : []
        let index = order.indexOf(string)
        if (index > -1) {
            order[index] = "-" + string
        } else {
            index = order.indexOf("-" + string)
            index > -1 ? order.splice(index, 1) : order.unshift(string)
        }
        this.setState({ orderBy: order })
    }

    render() {
        return (
            <Container fluid className="bos-listing-container">
                <Row>
                    <Col xs={8}>
                        <SubrogationClaimListHeader
                            filterValues={this.state.filterValues}
                            setFilterValues={(filterValues) => this.setState({ filterValues })}
                            {...this.props}
                        />
                    </Col>
                    <Col xs={4}>
                        <SubrogationClaimActions
                            columnConfig={this.state.columnConfig}
                            setColumnConfig={this.setColumnConfig}
                            tableId="subrogation_claim"
                            defaultColumnConfig={getDefaultColumnConfig()}
                            {...this.props}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col sm="12">
                        <SubrogationClaimList
                            columnConfig={this.state.columnConfig}
                            searchTerm={this.state.filterValues?.searchTerm || null}
                            tpaId={this.state.filterValues?.tpaId || null}
                            status={this.state.filterValues?.status || null}
                            inLitigation={this.state.filterValues?.inLitigation !== undefined ? this.state.filterValues.inLitigation : null}
                            incidentBranchIds={this.state.filterValues?.incidentBranchIds || null}
                            assignedTo={this.state.filterValues?.assignedTo || null}
                            incidentDate={this.state.filterValues?.incidentDate || null}
                            dateAddedGte={this.state.filterValues?.dateAdded?.start || null}
                            dateAddedLte={this.state.filterValues?.dateAdded?.end || null}
                            requestedAmountGte={parseFloat(this.state.filterValues?.requestedAmountGte) || null}
                            requestedAmountLte={parseFloat(this.state.filterValues?.requestedAmountLte) || null}
                            grossCollectedGte={parseFloat(this.state.filterValues?.grossCollectedGte) || null}
                            grossCollectedLte={parseFloat(this.state.filterValues?.grossCollectedLte) || null}
                            isArchived={this.state.filterValues?.isArchived !== undefined ? this.state.filterValues.isArchived : null}
                            externalIdIsNull={this.state.filterValues?.externalIdIsNull !== undefined ? this.state.filterValues.externalIdIsNull : null}
                            orderBy={this.state.orderBy}
                            updateOrder={this.updateOrder}
                        />
                    </Col>
                </Row>
            </Container>
        )
    }
}

export default withApolloClient(
    SubrogationClaimListContainer
)
